<template>
  <div class="badge-wrapper">
    <slot name="default" />
    <button
      v-if="id"
      :id="id"
      class="question"
      :class="[{classname: classname}]"
      :style="wrappingStyle"
    >
      ?
    </button>
    <button
      v-else
      class="question"
      :class="[{classname: classname}]"
      :style="wrappingStyle"
    >
      ?
    </button>
  </div>
</template>

<script>

export default {
  name: "QuestionBadge",

  props: {
    id: {
      type: String,
      required: false
    },
    classname: { // may want to add this if there will be multiple QuestionBadges on the page where you want to provide the same Pendo response
      type: String,
      required: false
    },
    top: {
      type: Number,
      default: -1
    },
    left: {
      type: Number,
      default: -1
    }
  },

  computed: {
    slotEmpty() {
      return this.$slots.default === undefined
    },
    wrappingStyle() {
      return (this.slotEmpty ? '' : `position: absolute; top: ${this.top}px; left: ${this.left}px;`);
    }
  },

  created() {},

  mounted() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
@use "../../scss/_variables.scss";

.badge-wrapper {
  display: inline-block;
  position: relative;
  padding-left: 1rem;
}

.question {
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: variables.$charcoal;
  color: variables.$pure-white;

  position: absolute;
  top: -1px;
  left: -1px;

  font-family: variables.$font-primary;
  font-size: 0.75rem;

  height: 1rem;
  width: 1rem;

  border-radius: 15rem;

  &:hover {
    cursor: pointer;
  }
}
</style>
